import { createContext, useContext } from 'react';

import { ModalId } from '@/types/modal.type';

export type AppModalData = {
    id: ModalId;
    payload?: any;
};

export type AppModalContextType = {
    modalData: AppModalData | null;
    dialogElementRef: React.RefObject<HTMLDialogElement> | null;
    setModalData: (data: AppModalData | null) => void;
    setDialogElementRef: (
        ref: React.RefObject<HTMLDialogElement> | null,
    ) => void;
};

export const AppModalContext = createContext<AppModalContextType>({
    modalData: null,
    dialogElementRef: null,
    setModalData: () => {},
    setDialogElementRef: () => {},
});

export function useAppModal() {
    return useContext(AppModalContext);
}
